import { useOnlyClientRendering } from '@ucheba/utils/hooks/useOnlyClientRendering'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { coreSelectors } from '@ucheba/store/core'
import { questionHighlighting, questionHighlightingParams } from './constants'

type TUseButtonHint = () => {
  isOpen: boolean
  onClose: () => void
}

export const useButtonHint: TUseButtonHint = () => {
  const isClient = useOnlyClientRendering()
  const isTouch = useSelector(coreSelectors.isTouch)

  const [open, setOpen] = useState(
    isClient && !localStorage.getItem('wantToStudyButtonStepsShow')
  )

  const onClose = (): void => {
    localStorage.setItem('wantToStudyButtonStepsShow', JSON.stringify(true))
    setOpen(false)
  }

  useEffect(() => {
    const session = sessionStorage.getItem('wantToStudyButtonStepsShow')

    if (!isTouch || session) {
      setOpen(!localStorage.getItem('wantToStudyButtonStepsShow'))
    } else {
      sessionStorage.setItem('wantToStudyButtonStepsShow', '1')
    }
  }, [])

  const handleBtnAnimation = (): void => {
    window.scrollTo({ top: 0, behavior: 'smooth' })

    setTimeout(() => {
      const item = document.getElementById('admissionPlanButtonCircle')

      item?.animate(questionHighlighting, questionHighlightingParams)
    }, 1000)
  }

  return {
    isOpen: isClient && open,
    onClose,
    handleBtnAnimation,
  }
}
